import React from 'react';
import { termsAndConditions } from '../../terms';
import styles from '../../styles/BookingModal.module.css';

interface TermsAndServicesProps {
  acceptedTerms: boolean;
  setAcceptedTerms: React.Dispatch<React.SetStateAction<boolean>>;
  showTerms: boolean;
  setShowTerms: React.Dispatch<React.SetStateAction<boolean>>;
  phoneNumbersMatch: boolean;
  hasPhoneNumbers: boolean;
  organizerTerms?: string;
}

const TermsAndServices = ({
  acceptedTerms,
  setAcceptedTerms,
  showTerms,
  setShowTerms,
  phoneNumbersMatch,
  hasPhoneNumbers,
  organizerTerms
}: TermsAndServicesProps) => {
  return (
    <>
      <div className={styles.termsContainer}>
        <p className={styles.termsLabel}>
          By proceeding i accept <span
            onClick={() => setShowTerms(true)}
            className="text-indigo-500 hover:text-indigo-400 cursor-pointer underline"
          >
            terms and conditions
          </span>
        </p>
      </div>

      {showTerms && (
        <div className={styles.termsModal}>
          <div className="max-h-[60vh] overflow-y-auto p-4 border rounded">
            {organizerTerms ? (
              <div className="whitespace-pre-wrap">{organizerTerms}</div>
            ) : (
              <div>{termsAndConditions}</div>
            )}
          </div>
          <div className="flex justify-end mt-2">
            <button
              onClick={() => setShowTerms(false)}
              className={`${styles.button} ${styles.secondaryButton}`}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TermsAndServices;